// extracted by mini-css-extract-plugin
export default {"wrapperBtn":"ToTop_wrapperBtn__0QuwO"};